/* Side cart: a "Clear cart" control with a second tap to confirm */
(function () {
  'use strict';
  var dr = document.querySelector('.zdrawer');
  if (!dr) return;
  var st = document.createElement('style');
  st.textContent = '.zdrawer-clear{display:flex;align-items:center;justify-content:flex-end;flex-wrap:wrap;gap:8px;padding:10px 20px 0;font-size:13.5px;color:#3c4a38}'
    + '.zdrawer-clear button{display:inline-flex;align-items:center;gap:6px;font:inherit;font-weight:600;font-size:13px;line-height:1;padding:8px 13px;border-radius:16px;border:1px solid rgba(20,48,28,.16);background:#fff;color:#14301c;cursor:pointer;transition:background .2s ease,color .2s ease,border-color .2s ease}'
    + '.zdrawer-clear button:hover{border-color:#5b3fa0;color:#5b3fa0}'
    + '.zdrawer-clear button[data-zclear-yes]{background:#b3342f;border-color:#b3342f;color:#fff}'
    + '.zdrawer-clear button[data-zclear-yes]:hover{background:#932722;border-color:#932722;color:#fff}'
    + '.zdrawer-clear button:disabled{opacity:.5;cursor:wait}'
    + '.zdrawer-clear span{margin-right:auto;font-weight:600}';
  document.head.appendChild(st);
  var BIN = '<svg aria-hidden="true" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7h16M9 7V4.5h6V7M6.5 7l1 13h9l1-13M10 11v5.5M14 11v5.5"></path></svg>';
  function idle(bar) { bar.innerHTML = '<button type="button" data-zclear>' + BIN + 'Clear cart</button>'; }
  function add() {
    var list = dr.querySelector('.zdrawer-items');
    if (!list || dr.querySelector('.zdrawer-clear')) return;
    var bar = document.createElement('div');
    bar.className = 'zdrawer-clear';
    idle(bar);
    list.parentNode.insertBefore(bar, list);
  }
  new MutationObserver(add).observe(dr, { childList: true });
  add();
  dr.addEventListener('click', function (e) {
    var bar = dr.querySelector('.zdrawer-clear');
    if (!bar) return;
    if (e.target.closest('[data-zclear]')) {
      bar.innerHTML = '<span>Remove everything from your cart?</span><button type="button" data-zclear-no>Keep items</button><button type="button" data-zclear-yes>Yes, clear</button>';
      return;
    }
    if (e.target.closest('[data-zclear-no]')) { idle(bar); return; }
    var yes = e.target.closest('[data-zclear-yes]');
    if (!yes) return;
    [].forEach.call(bar.querySelectorAll('button'), function (b) { b.disabled = true; });
    fetch('/cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } })
      .then(function () {
        var cart = document.querySelector('.zcart-btn');
        if (cart) cart.click(); else location.reload();
      })
      .catch(function () { idle(bar); });
  });
})();

/* Shop Zeel button: with a mouse, the menu opens on hover and a click goes to the full range.
   On touch screens the button only opens and closes the menu. */
(function () {
  'use strict';
  var root = document.querySelector('[data-zmenu-root]');
  if (!root) return;
  var btn = root.querySelector('[data-zmenu-btn]');
  var panel = root.querySelector('[data-zmenu-panel]');
  if (!btn || !panel) return;
  btn.addEventListener('click', function (e) {
    if (!e.isTrusted || panel.hidden) return;
    if (!(window.matchMedia && window.matchMedia('(hover: hover)').matches)) return;
    var range = document.getElementById('range');
    if (range) {
      range.scrollIntoView({ behavior: 'smooth', block: 'start' });
      if (history.replaceState) history.replaceState(null, '', '#range');
    } else {
      location.href = '/#range';
    }
  }, true);
})();
